export default __webpack_public_path__ + "static/media/eyp.6ebb0a34.png";